<template>
    <div class="material-list-wrap">
        <div class="mr10 material-item" v-for="(material, ii) in list" :key="ii">
            <div class="material-view">
                <el-popover
                    placement="top"
                    width="500"
                    popper-class="mi-batch-material-pre-popover"
                    @hide="hidePopCon"
                    trigger="hover">
                    <div class="pop-content">
                        <img class="pre-material" v-if="material.type == 1" :src="material.img_full_material_url||material.full_material_url"/>
                        <video class="pre-material"
                               preload="none"
                               controls="controls"
                               :poster="material.img_full_material_url"
                               :src="material.full_material_url"
                               v-if="material.type == 3"
                        ></video>
                    </div>
                    <div slot="reference">
                        <div class="mini-material-wrap">
                            <img class="mini-material" :src="material.img_full_material_url||require('@/assets/img/mi-no-img.png')"/>
                        </div>
                    </div>
                </el-popover>
            </div>
            <el-tooltip class="item" effect="dark" :content="material.material_name" placement="top">
                <div class="ellipsis" style="display: block;">
                    <p class="material-name-text ellipsis tac">{{material.material_name}}</p>
                </div>
            </el-tooltip>

        </div>
    </div>
</template>

<script>
    export default {
        name: "IdeaColumnTemp",
        props:{
            list:{
                type:Array,
                default:()=>{
                    return [];
                },
            },
        },
        data(){
            return {
            }
        },
        methods:{
            hidePopCon(){
                let $videos = document.querySelectorAll('.mi-batch-material-pre-popover video');
                $videos.forEach(item=>{
                    item.pause();
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .material-list-wrap{
        display: flex!important;
    }

    .material-item{
        width: 80px;
        .mini-material{
            max-width: 100%;
            max-height: 80px;
            float: left;
        }
        .mini-material-wrap{
            height: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: dashed 1px #ddd;
            background: #fafafa;
        }
    }

    .material-name-text{
        padding: 0!important;
        line-height: 16px;
    }
</style>
<style lang="scss">
    .el-popover.mi-batch-material-pre-popover{
        .pop-content{
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            width: 100%;
            height: 100%;

            video,img{
                max-height: 400px;
                max-width: 500px;
            }
        }

    }
</style>
